export default function sendLogoutForm() {
  $('form.logout-form').on('click', 'button', function () {
    $(this).prop('disabled', true);
    $('form.logout-form').submit();
  })
}
